import { Plus } from "@/components/icons";
import { Button } from "@/components/kit";

type ProductsPageHeaderProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function ProductsPageHeader({
  canManage,
  onCreate,
}: ProductsPageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex flex-col gap-1">
        <h2 className="font-display text-2xl text-foreground sm:text-3xl">
          ສິນຄ້າ & ສະຕັອກ
        </h2>
        <p className="text-muted-foreground text-sm">
          ຄລັງສິນຄ້າອ້າງອີງຮູບ — ເລືອກສິນຄ້າໃຫ້ລູກຄ້າໃນແຊັດ
        </p>
        <div className="mt-2 h-0.5 w-16 rounded-full bg-secondary/70" />
      </div>
      {canManage ? (
        <Button className="shrink-0 rounded-full shadow-sm" onClick={onCreate}>
          <Plus data-icon="inline-start" />
          ເພີ່ມສິນຄ້າ
        </Button>
      ) : null}
    </div>
  );
}
